import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class DataService {
    /**
     * Endpoint
     */
    private _endPoint: string;
    private _endPointGenba: string;

    /**
     * Creates an instance of data service.
     * @param http http client
     */
    constructor(private http: HttpClient) {
        this._endPoint = environment.baseURL + '';
        this._endPointGenba = environment.baseUrlGenba + '';
    }

    /**
     * Make request with get request
     * @template T interface template
     * @param  url url of resource
     * @param params http parameters
     * @returns Observables<T>
     */
    getRequest<T>(url: string, params?: Record<string, unknown>): Observable<T> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
        });

        let httpParams = new HttpParams();

        if (typeof params === 'object') {
            Object.keys(params).forEach((key) => {
                if (typeof params[key] !== 'undefined') {
                    httpParams = httpParams.append(key, params[key] as any);
                }
            });
        }

        return this.http.get<T>(this._endPoint + url, {
            params: httpParams,
            headers: headers,
            withCredentials: false,
        });
    }

    getRequestGenba<T>(url: string, params?: Record<string, unknown>): Observable<T> {
        let headers = new HttpHeaders({
            'X-API-Key': '2EZmQBMMRY6ZeSbfOhVAYLsd4YXNShvFKaf_JmFBA5g=',
        });

        let httpParams = new HttpParams();

        if (typeof params === 'object') {
            Object.keys(params).forEach((key) => {
                if (typeof params[key] !== 'undefined') {
                    httpParams = httpParams.append(key, params[key] as any);
                }
            });
        }

        return this.http.get<T>(this._endPointGenba + url, {
            params: httpParams,
            headers: headers,
            withCredentials: false,
        });
    }

    /**
     * Post Request Wrapper
     *
     * @param url url of posted data
     * @param body data will be sended
     */
    postRequest<T>(url: string, body: any): Observable<T> {
        return this.http.post<T>(this._endPoint + url, body);
    }

    /**
     * Delete request wrapper
     *
     * @param url url of deleted data
     */
    deleteRequest<T>(url: string): Observable<T> {
        return this.http.delete<T>(this._endPoint + url);
    }

    /**
     * Put request wrapper
     *
     * @param url url of api
     * @param body data
     */
    putRequest<T>(url: string, body: any): Observable<T> {
        return this.http.put<T>(url, body);
    }

    /**
     * Head request wrapper
     *
     * webpack not allowed this request by design
     *
     * @param url url of api
     * @returns Observable
     */
    headRequest(url: string): Observable<any> {
        return this.http.head(url, { observe: 'response' });
    }

    /**
     * Upload file
     *
     * @param url url of uploaded data
     * @param formData form data
     */
    uploadFile(
        url: string,
        formData: FormData,
        method: string = 'post'
    ): Observable<any> {
        return this.http.post<any>(url, formData, {
            reportProgress: true,
            observe: 'events',
        });
    }

    /**
     * check file exist
     *
     * @param url url of file
     */
    fileExists(url: string) {
        const xhr = new XMLHttpRequest();
        xhr.open('HEAD', url, false);
        xhr.send();

        return xhr.status;
    }

    /**
     * Change endpoint
     * @param endpoint new endpoint that will be added
     */
    changeEndpoint(endpoint: string): void {
        this._endPoint = endpoint;
    }

    /**
     * get endpoint
     * @returns endpoint
     */
    getEndpoint(): string {
        return this._endPoint;
    }

    /**
     * get file from asset
     *
     * @param urlToFile string
     * @returns Observable<T>
     */
    getAssetJson<T>(urlToFile: string): Observable<T> {
        return this.http
            .get<T>('assets/' + urlToFile);
    }

    /**
     * download file from server
     *
     * @param endpoint
     * @param params
     * @returns
     */
    download(endpoint: string, params: any): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
        });

        let httpParams = new HttpParams();

        if (typeof params === 'object') {
            Object.keys(params).forEach((key) => {
                if (typeof params[key] !== 'undefined') {
                    httpParams = httpParams.append(key, params[key]);
                }
            });
        }

        return this.http.get<any>(this._endPoint + endpoint, {
            params: httpParams,
            observe: 'response',
            headers: headers,
            withCredentials: false,
            responseType: 'blob' as 'json'
        });
    }

    getImg(url: string) {
        return this.http.get(url, { responseType: 'arraybuffer' })
    }
}
